import { useState } from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Typography, Tooltip, Icon } from 'shared/ui'
import styles from './styles.module.scss'

type RoleChipProps = {
  roleLabel: string
  hasCustomPermissions?: boolean
  disabled?: boolean
}

export const RoleChip = observer(
  ({ roleLabel, hasCustomPermissions = false, disabled }: RoleChipProps) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)

    return (
      <div
        className={classNames(styles.roleChip, {
          [styles.hoverState]: hasCustomPermissions,
          [styles.disabled]: disabled,
        })}
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
      >
        <Typography
          variant='body-md-regular'
          ariaLabel='MemberRoleChip'
          className={styles.capitalize}
        >
          {roleLabel}
        </Typography>
        {hasCustomPermissions && (
          <Tooltip
            placement='top'
            label='Custom permissions'
            open={hasCustomPermissions && tooltipOpen}
            margin={0}
            PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 15],
                  },
                },
              ],
            }}
          >
            <Icon fontSize={14} icon={'infoCircle'} color={'var(--content-primary-tertiary)'} />
          </Tooltip>
        )}
      </div>
    )
  }
)
